module.exports = __webpack_public_path__ + "static/Grosvenor_blue-b2d955a3315b5b00441441fc8255b1e4.png";